import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Appcost(props) {
  return (
    <div className="p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Scalability">
              <h2>
                Enhance business scalability through Infrastructure Migration
                Services
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Empower your business to have a smoother transition process with
              our infrastructure migration services. Moving your infrastructure
              to more advanced, scalable platforms helps you to immediately
              respond to the dynamic market forces and offers you a high level
              of efficiency in your operations. Whether you're optimizing your
              infrastructure for performance, scalability, and agility while
              growing your operations or coping with increased workloads. It is
              our experienced team that guarantees it to be done right. Realize
              improved scalability and be able to stand when shifting to
              infrastructure migration by relying on its transformative
              capability.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Appcost;
